import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SupportAddressesTab from './SupportAddressesTab';
import StaffTab from './StaffTab';
import GroupsTab from './GroupsTab';
import GroupDetail from './GroupDetail';

export default function DomainAdminApp() {
  return (
    <Routes>
      <Route index element={<Navigate to="addresses" replace />} />
      <Route path="addresses" element={<SupportAddressesTab />} />
      <Route path="staff" element={<StaffTab />} />
      <Route path="groups" element={<GroupsTab />} />
      <Route path="groups/:groupId" element={<GroupDetail />} />
    </Routes>
  );
}
